function BarChart(dom, data) {
  var Chart = window.Chart;
  new Chart(dom, {
    type: "bar",
    options: {
      scales: {
        yAxes: [
          {
            ticks: {
              callback: function (e) {
                return e;
              },
            },
            gridLines: {
              display: false,
            },
          },
        ],
      },
    },
    data,
  });
  return Chart;
}

module.exports = {
  BarChart,
  randomString: (length) => {
    var result = [];
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result.push(
        characters.charAt(Math.floor(Math.random() * charactersLength))
      );
    }
    return result.join("").toLowerCase();
  },
  setThemeMode: (mode) => {
    localStorage.setItem("themeMode", mode);
    if (mode === "light")
      document
        .getElementById("theme")
        .setAttribute("href", "/assets/css/theme.bundle.css");
    else
      document
        .getElementById("theme")
        .setAttribute("href", "/assets/css/theme-dark.bundle.css");
  },
  validURL: (str) => {
    var pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return !!pattern.test(str);
  },
  getCalculatedPrice: (pricing, gb, addPrice, index) => {
    var price = 0;
    if (index === 1) {
      price = ((gb - 50) / 50) * addPrice;
    } else if (index === 2) {
      price = ((gb - 100) / 50) * addPrice;
    } else {
      price = ((gb - 150) / 50) * addPrice;
    }
    console.log(price);
    return price + pricing;
  },
};
